<template>
  <a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <template #footer>
			<a-button type="primary" @click="onPass">接受</a-button>
			<a-button type="danger" @click="onNoPass">已拒绝</a-button>
		</template>
    <div class="top">
      <div class="imgBox" v-if="form.headShot">
        <img-upload v-model:value="form.headShot" :showBtn="false" disabled />
      </div>
      <div class="rightBox">
        <p class="name">{{ form.name }}</p>
        <p class="second">{{ form.sex == '0' ? '男' : '女' }}&nbsp; / {{ form.age }}岁&nbsp; / {{ form.yearsService
        }}年工作经验&nbsp; / <dict-render :dict-obj="dictObjs['education_background']" v-if="form.educationBackground"
            :text="form.educationBackground"></dict-render>
        </p>
        <p class="second">
          <mail-outlined />&nbsp; {{ form.emailAddress }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <phone-outlined />&nbsp;
          {{ form.phoneNumber }}
        </p>
      </div>
    </div>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="现居地">{{ form.provject }}</a-descriptions-item>
      <a-descriptions-item label="期望职位">
        <dict-render :dict-obj="dictObjs['hope_job']" v-if="form.jobTitleExpectation"
          :text="form.jobTitleExpectation"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="期望城市">{{ form.provject }}</a-descriptions-item>
      <a-descriptions-item label="期望薪资">
        <dict-render :dict-obj="dictObjs['salary']" v-if="form.salaryExpectation"
          :text="form.salaryExpectation"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="期望从事行业">
        <dict-render :dict-obj="dictObjs['research_field']" v-if="form.businessExpectation"
          :text="form.businessExpectation"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="入职时间">{{ form.estimatedTimeEntry ? form.estimatedTimeEntry.split(' ')[0] : ''
      }}</a-descriptions-item>
      <a-descriptions-item label="工作性质">
        <dict-render :dict-obj="dictObjs['work_type']" v-if="form.natureWork" :text="form.natureWork"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="目前工作状态">
        <dict-render :dict-obj="dictObjs['work_status']" v-if="form.stateWork" :text="form.stateWork"></dict-render>
      </a-descriptions-item>
      <a-descriptions-item label="自我评价">{{ form.selfEvaluation }}</a-descriptions-item>
    </a-descriptions>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane key="1" tab="工作经历">
        <workExprise />
      </a-tab-pane>
      <a-tab-pane key="2" tab="教育经历">
        <eduExprise />
      </a-tab-pane>
      <a-tab-pane key="3" tab="项目经验">
        <projectExprise />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import workExprise from './workExprise';
import eduExprise from './eduExprise';
import projectExprise from './projectExprise';
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";
import { isPassInfo } from "@/api/educationService";
import { message } from "ant-design-vue";
export default {
  name: "formModal",
  components: {
    DictRender, workExprise, eduExprise, projectExprise
  },

  mixins: [formMixin, dictMixin],
  data() {
    return {
      dictNames: 'research_field,education_background,salary,work_experience,work_type,fringe_benefits,hope_job,work_status',
      form: {},
      activeKey: "1"
    }
  },
  methods: {
		onPass() {
			this.postAction({
				url: isPassInfo.isPass,
				params: { isPass: 1, interviewInvitationId: this.form.interviewInvitationId }
			}).then(() => {
				message.success('操作成功！')
				this.onClose()
			})
		},
		onNoPass() {
			this.postAction({
				url: isPassInfo.isPass,
				params: { isPass: 2, interviewInvitationId: this.form.interviewInvitationId }
			}).then(() => {
				message.success('操作成功！')
				this.onClose()
			})
		},
	}
}
</script>
<style scoped lang="less">
.top {
  overflow: hidden;

  .imgBox {
    float: left;
    margin-right: 20px;
  }

  .rightBox {
    float: left;
    color: #333;

    .name {
      font-weight: 700;
      font-size: 24px;
    }

    .second {
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
